import api from '../services/api';

/**
 * Get all categories with pagination support
 * @param {Object} queryParams - Pagination, sorting, and filtering parameters
 * @returns {Promise<Object>} The categories data with pagination metadata
 */
export async function getCategories(queryParams) {
  try {
    let endpoint = '/api/categories';
    if (queryParams && queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
}

/**
 * Get a specific category
 * @param {number} id - The category ID
 * @returns {Promise<Object>} The category data
 */
export async function getCategory(id) {
  try {
    const response = await api.get(`/api/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching category ${id}:`, error);
    throw error;
  }
}

/**
 * Create a new category
 * @param {Object} categoryData - The category data
 * @returns {Promise<Object>} The response data
 */
export async function createCategory(categoryData) {
  try {
    const response = await api.post('/api/categories', categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
}

/**
 * Update an existing category
 * @param {number} id - The category ID
 * @param {Object} categoryData - The updated category data
 * @returns {Promise<Object>} The response data
 */
export async function updateCategory(categoryData) {
  try {
    const response = await api.post('/api/categories/update', categoryData);
    return response.data;
  } catch (error) {
    console.error(`Error updating category:`, error);
    throw error;
  }
}

/**
 * Delete a category
 * @param {number} id - The category ID
 * @returns {Promise<Object>} The response data
 */
export async function deleteCategory(id) {
  try {
    const response = await api.delete(`/api/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting category ${id}:`, error);
    throw error;
  }
}

/**
 * Get all category groups
 * @returns {Promise<Object>} The category groups data
 */
export async function getCategoryGroups() {
  try {
    const response = await api.get('/api/categories/groups');
    return response.data;
  } catch (error) {
    console.error('Error fetching category groups:', error);
    throw error;
  }
}

/**
 * Get a specific category group
 * @param {number} id - The category group ID
 * @returns {Promise<Object>} The category group data
 */
export async function getCategoryGroup(id) {
  try {
    const response = await api.get(`/api/categories/groups/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching category group ${id}:`, error);
    throw error;
  }
}

/**
 * Create a new category group
 * @param {Object} groupData - The category group data
 * @returns {Promise<Object>} The response data
 */
export async function createCategoryGroup(groupData) {
  try {
    const response = await api.post('/api/categories/groups', groupData);
    return response.data;
  } catch (error) {
    console.error('Error creating category group:', error);
    throw error;
  }
}

/**
 * Update an existing category group
 * @param {number} id - The category group ID
 * @param {Object} groupData - The updated category group data
 * @returns {Promise<Object>} The response data
 */
export async function updateCategoryGroup(groupData) {
  try {
    const response = await api.post('/api/categories/groups/update', groupData);
    return response.data;
  } catch (error) {
    console.error(`Error updating category group:`, error);
    throw error;
  }
}

/**
 * Delete a category group
 * @param {number} id - The category group ID
 * @returns {Promise<Object>} The response data
 */
export async function deleteCategoryGroup(id) {
  try {
    const response = await api.delete(`/api/categories/groups/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting category group ${id}:`, error);
    throw error;
  }
}
